import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['startRoundAction', 'finishRoundAction', 'closeModal']),
    roundName(list, i) {
      const round = list[i];
      return this.$t(
        '_web_tournaments-tableview_round-basic-name',
        'Round {number}',
        { number: +round.index + 1 }
      );
    },
    startRound({ roundID }) {
      this.closeModal();
      return this.startRoundAction({ roundID })
        .then(() => {
          this.forceUpdate = true;
          return Promise.all([
            this.getMatches(
              roundID,
              this.firstVisibleMatch,
              this.firstVisibleMatch + this.pageSize
            ),
            this.getMatches(
              roundID + 1,
              this.firstVisibleMatch,
              this.firstVisibleMatch + this.pageSize
            ),
          ]);
        })
        .then(() => {
          this.$refs.grid.forceRender();
        })
        .catch(error => {
          this.errorNotify(error);
          this.forceUpdate = false;
        });
    },
    finishRound({ roundID }) {
      this.closeModal();
      return this.finishRoundAction({ roundID })
        .then(() => {
          this.forceUpdate = true;
          return Promise.all([
            this.getMatches(
              roundID,
              this.firstVisibleMatch,
              this.firstVisibleMatch + this.pageSize
            ),
            this.getMatches(
              roundID + 1,
              this.firstVisibleMatch,
              this.firstVisibleMatch + this.pageSize
            ),
          ]);
        })
        .then(() => {
          this.$refs.grid.forceRender();
        })
        .catch(error => {
          this.errorNotify(error);
          this.forceUpdate = false;
        });
    },
  },
};
